import { render, staticRenderFns } from "./ModuleTutorialCounseling.vue?vue&type=template&id=5f00dcd0&scoped=true&lang=pug&"
import script from "./ModuleTutorialCounseling.vue?vue&type=script&lang=js&"
export * from "./ModuleTutorialCounseling.vue?vue&type=script&lang=js&"
import style0 from "./ModuleTutorialCounseling.vue?vue&type=style&index=0&id=5f00dcd0&lang=scss&scoped=true&"
import style1 from "./ModuleTutorialCounseling.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f00dcd0",
  null
  
)

export default component.exports